module.exports = __webpack_public_path__ + "img/icon-ozon.c956d113.svg";